export interface ApiGetHistoryListRequest {
    page: string;
    limit: string;
    type?: string;
}

export interface HistoryItem {
    task_id: string;
    title: string;
    is_read: boolean;
    updated_at: string;
    task_type: string;
    async_status: string;
    type?: string;
}

export interface ApiGetHistoryListResponse {
    page: string;
    limit: string;
    total_page: number;
    total: number;
    list: HistoryItem[];
}

export const GetHistoryList = Symbol('GetHistoryList');

export interface GetHistoryList {
    getHistoryList(data: ApiGetHistoryListRequest): Promise<ApiGetHistoryListResponse>;
}